import React from "react";
import { Box, Stack, Typography } from "@common/components/";
import { isEmpty, localUser } from "@util/utils";
import { Icons } from '@curves/ui-base';

/**
 * 店鋪庫存管理系統導覽選單使用者資訊
 * 顯示在選單底部，包含大頭像和使用者名稱
 */
const InventoryNavUserInfo = () => {
	const user = localUser.get();
	const employee = localUser.get("employee");

	// 優先顯示員工名稱，如果沒有則顯示使用者名稱
	const displayName = !isEmpty(employee) ? employee.displayName : user?.displayName || "";

	return (
		<Box className="club-inventory-nav-user-info">
			<Stack direction="row" alignItems="center" spacing={2}>
				<Icons.UserCircle htmlColor="#6e2f8e" />
				<Box className="club-inventory-nav-user-content">
					<Typography className="club-inventory-nav-user-title" variant="body1">
						目前身分
					</Typography>
					<Typography className="club-inventory-nav-user-name" variant="body1">
						{displayName}
					</Typography>
				</Box>
			</Stack>
		</Box>
	);
};

export default InventoryNavUserInfo;
